import userApi from "apis/userApi";
import { RootState, useAppDispatch, useAppSelector } from "cache/store";
import { Game3rdMenuItem } from "models/commonModel";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginHeader from "./login-header/LoginHeader";
import { LoginPayload } from "models/authModel";
import { animated, useTransition } from "@react-spring/web";
import { updateMessageUnread } from "features/msgSystemSlice";
import Fingerprint2 from "fingerprintjs2";
import styles from './header.styles';
import { DEVICE_INFO } from "constants/common";
import authApi from "apis/authApi";
import { ApiToken, cacheTokenBC, cacheTokenRH, cacheTokenXD, cacheUserInfo, login, logout, rememberAccountAction, updateAgentType } from "features/authSlice";
import toast from "react-hot-toast";
import { encode } from "punycode";
import classNames from "classnames";
import AccountHeader from "./account-header/AccountHeader";
import Button from "components/button/Button";
import { colors } from "constants/theme";
import HeaderMenu from "components/header-menu/HeaderMenu";
import Modal from "components/modal/Modal";
import AuthHeader from "components/auth-header/AuthHeader";
import FastTransferGame from 'components/transfer/FastTransferGame';
import UpdateUser from "components/update-user/UpdateUser";
import HandlerError from "helper/HandlerError";
import bcMiniGameApi from "apis/bc-minigame-api";
import xdMiniGameApi from "apis/xd-minigame-api";
import rongHoApi from "apis/rongho-api";

interface UserData {
  username: string;
  balance: string;
}

function Header() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { msgUnread } = useAppSelector((state: RootState) => state.system);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState<UserData>({} as UserData);
  const { isLogged, userInfo } = useAppSelector((state: RootState) => state.auth);
  const [showAuth, setShowAuth] = useState(false);
  const [showUpdateUser, setShowUpdateUser] = useState(false);
  const [showAccountInfo, setShowAccountInfo] = useState(false);
  const [gameTransferSelect, setGameTransferSelect] = useState<Game3rdMenuItem | null>(null);
  const [isReloadBalance, setIsReloadBalance] = useState(false);
  const [loginName, setLoginName] = useState('');

  const transitionMsg = useTransition(msgUnread > 0, {
    from: { scale: 0.5, opacity: 0 },
    enter: { scale: 1, opacity: 1 },
  });

  useEffect(() => {
    if (userInfo && isLogged) {
      setUserData({
        username: userInfo.loginname,
        balance: userInfo.balance
      });
    }
  }, [userInfo, isLogged]);

  useEffect(() => {
    if (isLogged) {
      const getmsgUnread = async () => {
        try {
          const { data } = await userApi.personMessageSearch({});
          if (!data.msg) {
            const msgUnreadList: any[] = data.reslist.filter((msg: any) => msg.viewtimes === 0);
            dispatch(updateMessageUnread(msgUnreadList.length));
          }
        }
        catch (error) {
          console.log(error)
        }
      };
      getmsgUnread();
    }
  }, [isLogged]);


  useEffect(() => {
    if ((window as any).requestIdleCallback) {
      requestIdleCallback(function () {
        Fingerprint2.get(function (component) {
          getFingerPrint(component);
        })
      })
    } else {
      setTimeout(() => {
        Fingerprint2.get(function (components) {
          getFingerPrint(components);
        })
      }, 500);
    }
  });

  const getFingerPrint = (components: Fingerprint2.Component[]) => {
    const values = components.map((component) => {
      return component.value;
    });
    DEVICE_INFO.uuid = Fingerprint2.x64hash128(values.join(''), 88);
    DEVICE_INFO.timezone = values[9];
    DEVICE_INFO.platform = values[16];
    DEVICE_INFO.resolution = values[6].join('x');
  }

  const loginMiniGameBC = async (payload: { password: string; rememberMe: boolean, username: string }) => {
    try {
        const { data } = await bcMiniGameApi.getToken(payload);
        dispatch(cacheTokenBC(data.id_token));
    } catch (error) {
        console.log(error);
    }
  };

  const loginMiniGameXD = async (payload: { password: string; rememberMe: boolean, username: string }) => {
    try {
        const { data } = await xdMiniGameApi.getToken(payload);
        dispatch(cacheTokenXD(data.id_token));
    } catch (error) {
        console.log(error);
    }
  };

  const loginMiniGameRH = async (payload: { password: string; rememberMe: boolean, username: string }) => {
    try {
        const { data } = await rongHoApi.getTokenRH(payload);
        dispatch(cacheTokenRH(data.id_token));
    } catch (error) {
        console.log(error);
    }
  };


  const submitLogin = async (payload: LoginPayload, showAlertSuccess: boolean, closeModal: boolean, rememberAccount?: boolean) => {
    const { un, pwd } = payload;
    setLoading(true);
    try {
      const { data } = await authApi.login(payload);
      if (data.msg === '') {
        //change state logged in store "auth slice"
        dispatch(login(true));

        if (closeModal) {
          setShowAuth(false);
        }

        if (showAlertSuccess) {
          toast.success('Đăng nhập thành công!');
          dispatch(ApiToken(data.token));
          loginMiniGameBC({ password: payload.pwd, rememberMe: false, username: payload.un });
          loginMiniGameXD({ password: payload.pwd, rememberMe: false, username: payload.un });
          loginMiniGameRH({ password: payload.pwd, rememberMe: false, username: payload.un });
        }

        //cache userinfo to store "auth slice"
        dispatch(cacheUserInfo(data.user));

        //cache agent type account
        let agentTypeUser = null;
        if (data.user.usertype === -2) {
          agentTypeUser = 1;
        } else if (data.user['param9'] && data.user['param9'] !== '') {
          agentTypeUser = 2;
        }
        localStorage.setItem("token", (data['token']));
				dispatch(ApiToken(data['token']));
        dispatch(updateAgentType(agentTypeUser));

        //cache remember account
        if (rememberAccount) {
          const rememberData = {
            account: encode(`${un}|${pwd}`),
            isRemember: true,
          };
          dispatch(rememberAccountAction(rememberData));
        } else {
          dispatch(rememberAccountAction({ isRemember: false, account: null }));
        }
      } else if (data.msg === '-1') {
        setShowUpdateUser(true);
        setLoginName(data.user.loginname);
      } else {
        toast.error(data.msg);
      }
    } catch (error) {
      console.log(error);
      // Trước đây lỗi bị nuốt im lặng: request lỗi (mạng/CORS/timeout) hoặc response
      // thiếu field khiến người dùng KHÔNG thấy gì mà cũng không đăng nhập được.
      // Luôn hiện thông báo để có lý do rõ ràng.
      toast.error('Đăng nhập thất bại. Vui lòng kiểm tra kết nối và thử lại.');
    } finally {
      setLoading(false);
    }
  }

  const refreshBalance = async () => {
    setIsReloadBalance(true);
    try {
      if(isLogged) {
        const { data } = await authApi.getUserInfo();
        HandlerError(
          data,
          () => {
            dispatch(cacheUserInfo(data));
        }, "getUserInfo"); 
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsReloadBalance(false);
    }
  }

  const changeWalletPage = (path: 'wl-depo' | 'wl-wdr' | 'fund-transfer') => {
    navigate(`/account?mode=${path}`);
  }

  const onLogout = () => {
    dispatch(logout(false));
    navigate('/');
  }

  const playGame = (game: Game3rdMenuItem) => {
    setGameTransferSelect(game);
  };

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.container}>
        <div className={styles.content}>
            <div className={styles.logo} onClick={() => navigate('/')}>
              <img src={require('assets/images/logos/logo.png')} alt="" />
            </div>
            {!isLogged ? (
              <LoginHeader onLogin={submitLogin} onShowAuth={() => setShowAuth(true)} />
            ) : (
              <div className={styles.userHeader}>
                <button type="button" className={`${styles.btnLeft} ${styles.btnBalance} ${isReloadBalance && styles.rotatingBalance}`} onClick={refreshBalance}>
                  <img src={require('assets/images/icons/refresh.png')} alt="" />
                  <p>{new Intl.NumberFormat().format(Number(userData.balance) || 0)} VND</p>
                </button>

                <div className={styles.wrapBtnAccount} onMouseEnter={() => setShowAccountInfo(true)} onMouseLeave={() => setShowAccountInfo(false)}>
                  <button type="button" className={classNames(`${styles.btnLeft} ${styles.btnAccount}`, { show: showAccountInfo })}>
                    {showAccountInfo ? (
                      <img className={styles.avatar} src={require('assets/images/icons/avatar-dark.png')} alt="" />
                    ) : (
                      <img className={styles.avatar} src={require('assets/images/icons/avatar.png')} alt="" />
                    )}
                    <p className={styles.username}>{userData.username}</p>
                    <img className={styles.arrow} src={require('assets/images/icons/arrow.png')} alt="" />
                  </button>
                  <AccountHeader show={showAccountInfo} onHide={() => setShowAccountInfo(false)} />
                </div>

                <div className={styles.noti} onClick={() => navigate(('/account?mode=noti-inbox'))}>
                  <img src={require('assets/images/icons/ring.png')} alt="" />
                  {msgUnread > 0 &&
                    transitionMsg(
                      (style, item) => item && (
                        <animated.span style={style} className={styles.countUnreadMsg}>
                          {msgUnread < 10 ? msgUnread : '9+'}
                        </animated.span>
                      )
                    )}
                </div>
                <div className={styles.btnAction}>
                  <Button className="deposit btn-active" text="Nạp Tiền" bg={colors.primary} minWidth="93px" borderColor={colors.primary} click={() => changeWalletPage('wl-depo')} bgHover={colors.blue} />
                  <Button className="deposit btn-wl"  text="Rút Tiền" minWidth="93px" borderColor={colors.secondary} click={() => changeWalletPage('wl-wdr')}/>
                  <Button className="deposit btn-funs"  text="Chuyển Quỹ" minWidth="93px" borderColor={colors.blue} click={() => changeWalletPage('fund-transfer')} width="unset" />
                  {/* <Button className="deposit"  text="Thoát" bg="none" borderColor="#927B7B" click={onLogout} /> */}
                  <button onClick={onLogout} className={styles.logout}>
                    <img className={styles.arrow} src={require('assets/images/icons/logout.png')} alt="" />
                    <span>Đăng Xuất</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        <HeaderMenu onPlayGame={playGame} />
      </div>

      <Modal isShow={showAuth} onClose={() => setShowAuth(false)} backdropColor="rgba(255,255,255, 0.7)" width="1050px">
          <AuthHeader onClose={() => setShowAuth(false)} onLogin={submitLogin} />
      </Modal>

      {/* popup chuyển quỹ nhanh */}
      <Modal isShow={Boolean(gameTransferSelect)} onClose={() => setGameTransferSelect(null)} width="520px">
          {gameTransferSelect ? <FastTransferGame gameData={gameTransferSelect} onClose={() => setGameTransferSelect(null)} /> : <></>}
      </Modal>

      {/* popup update user account */}
      <Modal isShow={showUpdateUser} onClose={() => setShowUpdateUser(false)} width="520px">
          <UpdateUser onClose={() => setShowUpdateUser(false)} loginName={loginName} />
      </Modal>
    </>
  );
}

export default Header;